import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { AuthContext } from "../../context/AuthContext";
import { toast } from "react-toastify";

const ClubDashboard = () => {
  const { t } = useContext(LanguageContext);
  const { user, setUser } = useContext(AuthContext); // ✅ setUser used
  
  const [donations, setDonations] = useState([]);
  const [tokenBalance, setTokenBalance] = useState(0);
  const [loading, setLoading] = useState(true);

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [logoPreview, setLogoPreview] = useState("");
  
  useEffect(() => {
    if (user?.logo) {
      const isAbsolute = user.logo.startsWith("http");
      setLogoPreview(isAbsolute ? user.logo : `${process.env.REACT_APP_API_BASE_URL}${user.logo}`);
    } else {
      setLogoPreview("/images/default-club-logo.png");
    }
  }, [user?.logo, user?.id]); // 👈 watch user.id too


  useEffect(() => {
    const fetchClubDonations = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/clubs/donations`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const data = await res.json();

        if (res.ok) {
          setDonations(data);
          const total = data.reduce((sum, d) => sum + parseFloat(d.amount), 0);
          setTokenBalance(total);
        } else {
          console.error("Error fetching donations:", data.message);
        }
      } catch (err) {
        console.error("Server error:", err);
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) fetchClubDonations();
  }, [user]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    setLogoPreview(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("logo", selectedFile);

    try {
      setUploading(true);
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/clubs/logo`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: formData,
      });

      const data = await res.json();

      if (res.ok) {
        const fullPath = `${process.env.REACT_APP_API_BASE_URL}${data.logo}`;
        setLogoPreview(fullPath);

        // ✅ update user context with new logo
        setUser((prevUser) => {
          if (prevUser.logo === data.logo) return prevUser;

          const updatedUser = { ...prevUser, logo: data.logo };
          localStorage.setItem("user", JSON.stringify(updatedUser)); // ✅ persist change
          return updatedUser;
        });
        toast.success(t("Logo uploaded successfully!"), {
          position: "top-right",
        });
      } else {
        // alert(data.error || "Upload failed");
        toast.error(t(data.error || "Upload failed"), {
          position: "top-right",
        });
      }
    } catch (err) {
      console.error("Upload error:", err);
      // alert("Upload failed=====");
      toast.error(t("Upload failed"), {
        position: "top-right",
      });
    } finally {
      setUploading(false);
    }
  };

  return (
    <section className="py-10 bg-gray-50 min-h-screen">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-10">
          {t("club_dashboard")} – {user?.name}
        </h2>

        {/*<div className="bg-white p-6 rounded-xl shadow-lg mb-8">
          <h3 className="text-xl font-semibold mb-4">{t("club_logo")}</h3>
          <div className="flex items-center gap-6 flex-col sm:flex-row">
            <img
              src={logoPreview}
              onError={(e) => (e.target.src = "/images/default-club-logo.png")}
              alt="Club Logo"
              className="w-28 h-28 object-cover rounded-lg border shadow"
            />
            <div className="flex flex-col gap-3">
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="block text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
              <button
                onClick={handleUpload}
                disabled={uploading}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-all disabled:opacity-50"
              >
                {uploading ? "Uploading..." : t("change_logo")}
              </button>
            </div>
          </div>
        </div>*/}

        <div className="bg-white p-6 rounded-xl shadow-lg">
          <h3 className="text-xl font-semibold mb-4">
            {t("sponsor_overview")} ({tokenBalance.toLocaleString()} {t("tokens")})
          </h3>

          {loading ? (
            <p>{t("loading")}</p>
          ) : donations.length === 0 ? (
            <p>{t("no_donations_yet")}</p>
          ) : (
            <table className="min-w-full table-auto text-left">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2">{t("sponsor_name")}</th>
                  <th className="px-4 py-2">{t("donated_tokens")}</th>
                  <th className="px-4 py-2">{t("date")}</th>
                </tr>
              </thead>
              <tbody>
                {donations.map((donation, idx) => (
                  <tr key={idx} className="border-t">
                    <td className="px-4 py-2 font-medium">{donation.sponsor_name}</td>
                    <td className="px-4 py-2">{parseFloat(donation.amount).toLocaleString()}</td>
                    <td className="px-4 py-2">{new Date(donation.created_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </section>
  );
};

export default ClubDashboard;
